// components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import Layout from './Layout';

const PrivateRoute = ({ children }) => {
  const isAuthenticated =!!localStorage.getItem('token'); // Replace with your authentication logic

  return isAuthenticated ? <Layout>{children}</Layout> : <Navigate to="/login" />;
};

export default PrivateRoute;
